import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import './CreditReferenceAgencies.scss'

export const CreditReferenceAgencies = () => {
    const { t } = useTranslation()
    const [isExpanded, setIsExpanded] = useState(false)

    return (
        <div className="credit-reference-agencies">
            <h2>{t('CreditReferenceAgencies')}</h2>

            <p>
                {t('CreditReferenceAgenciesDescription')}
            </p>

            {isExpanded && (
                <p>
                    {t('CreditReferenceAgenciesDetails')}
                </p>
            )}

            <button
                type="button"
                className="credit-reference-agencies-toggle"
                onClick={() => setIsExpanded((prev) => !prev)}
                aria-expanded={isExpanded}>
                {isExpanded
                    ? t('ShowLess')
                    : t('ShowMore')}

                <span
                    className={`credit-reference-agencies-chevron ${
                        isExpanded ? 'expanded' : ''
                    }`}
                    aria-hidden="true"
                />
            </button>
        </div>
    )
}